import { useState, useEffect, useCallback } from "react";

const SKIP_ENCOUNTERS_FILTER_KEY = "skip_encounters_filter";

export function useSkipEncountersFilter() {
  const [skipEncounterIds, setSkipEncounterIds] = useState<string[]>([]);

  // Load skip encounter IDs from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(SKIP_ENCOUNTERS_FILTER_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate that it's an array of strings
        if (Array.isArray(parsed) && parsed.every((id) => typeof id === "string")) {
          setSkipEncounterIds(parsed);
        }
      }
    } catch (error) {
      // Handle invalid JSON gracefully
      console.warn("Failed to parse skip encounters filter from localStorage:", error);
      setSkipEncounterIds([]);
    }
  }, []);

  const addSkipEncounterId = useCallback((id: string) => {
    setSkipEncounterIds((prev) => {
      // Prevent duplicates
      if (prev.includes(id)) {
        return prev;
      }
      const newIds = [...prev, id];
      localStorage.setItem(SKIP_ENCOUNTERS_FILTER_KEY, JSON.stringify(newIds));
      return newIds;
    });
  }, []);

  const removeSkipEncounterId = useCallback((id: string) => {
    setSkipEncounterIds((prev) => {
      const newIds = prev.filter((existingId) => existingId !== id);
      localStorage.setItem(SKIP_ENCOUNTERS_FILTER_KEY, JSON.stringify(newIds));
      return newIds;
    });
  }, []);

  const clearSkipEncounterIds = useCallback(() => {
    setSkipEncounterIds([]);
    localStorage.removeItem(SKIP_ENCOUNTERS_FILTER_KEY);
  }, []);

  return {
    skipEncounterIds,
    addSkipEncounterId,
    removeSkipEncounterId,
    clearSkipEncounterIds,
  };
}
